export default __webpack_public_path__ + "static/media/50years.6897d31e.webp";